import { SvgIconProps } from './icon-props';

export default function Information(props: SvgIconProps) {
	const { height = 20, width = 20, fill = '#1F6BC1', className, svgPathClassName } = props;
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.4811 7.9644H11.0337L8.48969 8.37482L8.3961 8.67277C8.4957 8.66676 8.58585 8.66332 8.66657 8.66332C8.82799 8.66332 8.95678 8.70711 9.0538 8.79383C9.14997 8.88055 9.19805 8.98015 9.19805 9.09178C9.19805 9.26608 9.14825 9.52366 9.04865 9.86539L8.00543 13.4535C7.91785 13.7394 7.87492 13.9755 7.87492 14.1619C7.87492 14.4418 7.97108 14.6728 8.16341 14.8565C8.35574 15.0394 8.61419 15.1313 8.93702 15.1313C9.78791 15.1313 10.5924 14.4727 11.3505 13.1556L11.0903 13.0062C10.7795 13.4904 10.5091 13.8262 10.2798 14.0125C10.1991 14.0872 10.1149 14.1241 10.0282 14.1241C9.97843 14.1241 9.93206 14.0992 9.88827 14.0494C9.84448 13.9996 9.82302 13.9498 9.82302 13.9C9.82302 13.8004 9.86337 13.5986 9.94408 13.2938L11.4811 7.9644ZM11.0157 4.50685C10.7109 4.50685 10.4533 4.61589 10.2421 4.83313C10.0309 5.05036 9.92531 5.31138 9.92531 5.61619C9.92531 5.92099 10.0326 6.1803 10.2473 6.3941C10.4619 6.60876 10.7178 6.71607 11.0157 6.71607C11.3205 6.71607 11.5807 6.60875 11.7988 6.3941C12.016 6.17945 12.1251 5.92016 12.1251 5.61619C12.1251 5.31138 12.0178 5.05122 11.8031 4.83313C11.5885 4.6159 11.3265 4.50685 11.0157 4.50685ZM10 0.625C4.82227 0.625 0.625 4.82227 0.625 10C0.625 15.1777 4.82227 19.375 10 19.375C15.1777 19.375 19.375 15.1777 19.375 10C19.375 4.82227 15.1777 0.625 10 0.625ZM10 18.75C5.16746 18.75 1.25 14.8325 1.25 10C1.25 5.16746 5.16746 1.25 10 1.25C14.8325 1.25 18.75 5.16746 18.75 10C18.75 14.8325 14.8325 18.75 10 18.75Z"
				fill={fill}
				className={svgPathClassName}
			/>
		</svg>
	);
}
